import { useNavigate } from "react-router-dom";
import { XCircle, ArrowLeft } from "lucide-react";
import AppLayout from "../components/AppLayout";

import { _t } from "@/lib/i18n";
/**
 * Payment Cancel page.
 * Shown when the user aborts the Stripe Checkout flow. Nothing is
 * activated: the service state stays exactly as it was before the
 * checkout was created.
 */
export default function PaymentCancel() {
  const nav = useNavigate();
  return (
    <AppLayout>
      <div className="max-w-xl mx-auto py-12">
        <div className="tc-card p-8 md:p-12 text-center" data-testid="payment-cancel">
          <div className="inline-flex w-16 h-16 items-center justify-center rounded-full border border-white/20 bg-white/5 mb-5">
            <XCircle className="w-8 h-8 text-white/60" />
          </div>
          <div className="text-[11px] uppercase tracking-[0.3em] text-white/50 mb-2">{_t("Pagamento annullato")}</div>
          <h2 className="font-display text-3xl text-white mb-3">{_t("Hai annullato il pagamento")}</h2>
          <p className="text-white/60 mb-8">{_t("Nessun addebito è stato effettuato. Il servizio non è stato attivato. Puoi riprovare quando vuoi.")}</p>
          <button data-testid="payment-cancel-back" onClick={() => nav(-1)} className="btn-ghost">
            <ArrowLeft className="w-4 h-4" />{" "}{_t("Torna indietro")}</button>
        </div>
      </div>
    </AppLayout>
  );
}
